export const Links = {
  FACEBOOK_URL: "https://www.facebook.com/sharer/sharer.php?u=",
  WHATSAPP_URL: "https://web.whatsapp.com/send?&text=",
  MAIL_URL: "mailto:",
  X_URL: "https://twitter.com/intent/tweet?url="
};